module.exports = __webpack_public_path__ + "img/BClogo.0176e7da.jpg";